<template>
  <div class="content-page mobile-app">
    <div class="mian-page">
      <div class="title-page">实名注册</div>
      <div class="backgroundBox">
        <div class="main-contentBox">
          <div class="re-contentBox">
            <div class="textBox">
              <div class="auth-tip">尊敬的申请人，请确认是您本人信息，并进行实名注册。</div>
              <el-form :model="ruleForm" :label-position="labelPosition" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm search-items">
                <el-form-item label="姓名" prop="loginName" class="col1-2">
                  <el-input :disabled="true" :placeholder="`请输入姓名`" v-model.trim="ruleForm.loginName" maxlength="20"></el-input>
                </el-form-item>
                <div class="col1-2"></div>
                <el-form-item label="身份证类型" prop="identificationType" disabled class="col1-2">
                  <el-select v-model="ruleForm.identificationType" disabled style="width:100%">
                    <el-option value="1001001" key="1001001" label="身份证"></el-option>
                  </el-select>
                </el-form-item>
                <div class="col1-2"></div>
                <el-form-item label="身份证号" prop="identificationCard" class="col1-2">
                  <el-input :disabled="true" :placeholder="`请输入身份证号码`" v-model.trim="ruleForm.identificationCard" maxlength="18"></el-input>
                </el-form-item>
                <div class="col1-2"></div>
                <el-form-item label="手机号码" prop="phone" class="col1-2">
                  <el-input :disabled="true" placeholder="请输入手机号码" v-model.trim="ruleForm.phone" maxlength="20"></el-input>
                </el-form-item>
                <div class="col1-2"></div>
                <el-form-item label="验证码" prop="verificationCode" class="phone col1-2">
                  <el-input placeholder="请输入验证码" v-model.trim="ruleForm.verificationCode" maxlength="8">
                    <template slot="append">
                      <div v-no-more-div v-if="!isDisabled">
                        <div v-no-more-div @click="getNumberCode" class="codebtn"> {{content}} </div>
                      </div>
                      <div v-else>
                        <div class="codebtn-gary"> {{content}} </div>
                      </div>
                    </template>
                  </el-input>
                </el-form-item>
                <div class="col1-2"></div>
                <el-form-item class="col1-2">
                  <el-checkbox v-model="agreePolicy">
                    <span class="privacy-link" @click.stop.prevent="goToPrivacyPolicy">上海复议个人信息保护政策</span>
                  </el-checkbox>
                </el-form-item>
              </el-form>
            </div>
          </div>
          <div class="btnLists">
            <div v-no-more-div class="border-btn" @click="cancel">取消</div>
            <div v-no-more-div class="primary-btn" style="margin-left: auto" @click="submitForm('ruleForm')">确定</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 隐私政策弹窗 -->
    <van-popup
      v-model="privacyPolicyVisible"
      position="bottom"
      :style="{ height: '80%', borderRadius: '20px 20px 0 0' }"
      :close-on-click-overlay="true"
    >
      <div class="privacy-popup">
        <div class="privacy-popup-header">
          <span class="privacy-popup-title">上海复议个人信息保护政策</span>
          <div class="privacy-popup-close" @click="closePrivacyPolicy">
            <span>✕</span>
          </div>
        </div>
        <div class="privacy-popup-content">
          <div class="privacy-content">
            <p class="privacy-paragraph">为切实保护上海行政复议掌上平台（以下简称上海复议）用户隐私权优化用户体验，上海复议根据现行法律法规及政策，制定本《个人信息保护政策》。本《个人信息保护政策》将详细说明上海复议在获取、管理及保护用户个人信息方面的政策及措施。本《个人信息保护政策》适用于上海复议向你提供的所有服务，无论你是通过计算机设备、移动终端或其他设备获得的上海复议服务。</p>
            
            <p class="privacy-paragraph">本《个人信息保护政策》是你使用上海复议服务及各项功能的基础性法律文件，我们希望你在使用上海复议服务前仔细阅读并明确你已经充分理解、接受本政策的内容，希望你可以根据自己的理解做出合适的选择。在我们更新本《个人信息保护政策》后，你继续使用我们的服务，即意味着你同意《个人信息保护政策》(含更新版本)内容，并且同意我们按照本《个人信息保护政策》收集、使用、保存和共享你的相关信息。</p>
            
            <p class="privacy-paragraph">本个人信息保护政策涉及的个人信息包括:基本信息(包括个人姓名、证件号码、联系方式、联系地址);个人位置信息;网络身份标识信息(包括系统账号、IP地址及密码)。</p>
            
            <div class="privacy-section">
              <h3 class="privacy-section-title">一、个人信息的收集</h3>
              <p class="privacy-paragraph">你已知悉且同意，在你注册上海复议账号或使用上海复议提供的服务时，上海复议将记录你提供的相关个人信息，如:密码、手机号码等，上述个人信息是你获得上海复议提供服务的基础。在你使用上海复议前，我们会引导你阅读本协议，并在你接受本协议的基础上，获得你的相关个人信息。如果你不同意提供个人信息，你将无法使用上海复议的部分功能和服务。</p>
              <p class="privacy-paragraph">上海复议仅会在出现下列情况时收集你的个人信息:</p>
              <p class="privacy-paragraph">在你注册上海复议账号时，我们会对你进行实名认证，至少会收集你的账户名称、密码、手机号码，你的姓名、身份证号、有关身份证明等信息。上海复议对你的这些隐私信息会加以最大程度的保护。如果你不提供这些信息，我们将无法提供相关服务。当涉及国家安全与利益、社会公共利益、与犯罪侦查有关的相关活动、你或他人生命财产安全但在特殊情况下无法获得你的及时授权、法律法规规定的其他情形下，上海复议可能在不经过你同意或授权的前提下，收集使用你的个人信息。</p>
              <p class="privacy-paragraph">另，如在上述场景之外获得你的个人信息，将重新征得你的明示同意，并在获得你明示同意前向你充分说明应用场景以及获取你相关信息的内容与范围。</p>
            </div>
            
            <div class="privacy-section">
              <h3 class="privacy-section-title">二、个人信息的保护和安全措施</h3>
              <p class="privacy-paragraph">1、上海复议将尽一切合理努力保护其获得的用户个人信息，并对个人信息进行保护。为防止用户个人信息在意外的、未经授权的情况下被非法访问、复制、修改、传送、遗失、破坏、处理或使用，上海复议已经并将继续采取以下措施保护你的个人信息:</p>
              <p class="privacy-paragraph">1)通过采取加密技术对用户个人信息进行加密保存。</p>
              <p class="privacy-paragraph">2)在个人信息使用时，我们会采用内容替换方式增强个人信息在使用中安全性</p>
              <p class="privacy-paragraph">2、个人信息安全事件的通知</p>
              <p class="privacy-paragraph">1)如发生个人信息引发的安全事件，上海复议将第一事件向相应主管机关报备，并即时进行问题排查，开展应急措施。</p>
              <p class="privacy-paragraph">2)还可能通过电话、短信等各种方式使用户知晓，在上海复议进行宣传，制止数据泄露。</p>
              <p class="privacy-paragraph">尽管已经采取了上述合理有效措施，并已经遵守了相关法律规定要求的标准，但上海复议仍然无法保证你的个人信息通过不安全途径进行交流时的安全性。因此，用户个人应采取积极措施保证个人信息的安全，如:定期修改账号密码，不将自己的账号密码等个人信息透露给他人。</p>
              <p class="privacy-paragraph">你知悉:上海复议提供的个人信息保护措施仅适用于上海复议，一旦你离开上海复议，浏览或使用其他网站、服务及内容资源，上海复议即没有能力及义务保护你在上海复议以外的网站提交的任何个人信息，无论你登录或浏览上述网站是否基于上海复议的链接或引导。</p>
              <p class="privacy-paragraph">网络环境中始终存在各种信息泄漏的风险，当出现意外事件、不可抗力等情形导致你的信息出现泄漏时，上海复议将极力控制局面，及时告知你事件起因、上海复议采取的安全措施、你可以主动采取的安全措施等相关情况。</p>
            </div>
            
            <div class="privacy-section">
              <h3 class="privacy-section-title">三、个人信息的存储</h3>
              <p class="privacy-paragraph">上海复议会采取合适的安全措施和技术手段存储及保护你的个人信息，以防止丢失、被误用、受到未授权访问或泄漏、被篡改或毁坏。你的个人信息存放在有密码控制的位于中国境内的服务器中，访问均是受到限制的。</p>
            </div>
            
            <div class="privacy-section">
              <h3 class="privacy-section-title">四、个人信息的使用和对外提供</h3>
              <p class="privacy-paragraph">未经你本人允许，上海复议不会向任何第三方公开(包括共享、转让、公开披露等方式)你的个人信息，下列情形除外:</p>
              <p class="privacy-paragraph">1、上海复议已经取得你或你监护人的授权或同意;</p>
              <p class="privacy-paragraph">2、司法机关或行政机关基于法定程序要求上海复议披露的;如上海复议将载明你个人信息的行政复议申请书，你提交的证据依据等材料发送对你作出行政行为的行政机关，由其提交行政复议答复，</p>
              <p class="privacy-paragraph">3、上海复议为维护自身合法权益而向用户提起诉讼或仲裁时;</p>
              <p class="privacy-paragraph">4、根据你与上海复议相关服务条款应用许可使用协议的约定;</p>
              <p class="privacy-paragraph">5、在法律允许的范围内，为保障上海复议、上海复议用户以及社会公共利益免受损害时;</p>
              <p class="privacy-paragraph">6、在不透露单个用户隐私资料的前提下，上海复议有权对整个用户数据库进行分析并对用户数据库进行适当的使用。</p>
            </div>
            
            <div class="privacy-section">
              <h3 class="privacy-section-title">五、个人信息的管理</h3>
              <p class="privacy-paragraph">当你完成上海复议的账号注册并进行合理和必要的身份验证后，你可以查阅、修改你提交给上海复议的个人信息。一般情况下，你可随时浏览、修改自己提交的信息，但出于安全性和身份识别的考虑，你可能无法修改注册时提供的某些初始注册信息及验证信息。</p>
              <p class="privacy-paragraph">你有权自主更新或更正你的个人信息。在你进行信息更新更正之前，我们会首先验证你的身份，其次才能进行信息的更正与更新。你可以自主注销上海复议账号，注销后上海复议不再收集你的个人信息。在你注销你的账号之前，上海复议将验证你的个人身份、安全状态、账户密码等信息。你注销账号的行为是不可逆的行为，一旦你注销你的账号，上海复议将删除有关你账户的一切信息，并保证这些信息不会泄露，同时，你也无法通过已注销的账户获得上海复议的服务。</p>
            </div>
            
            <div class="privacy-section">
              <h3 class="privacy-section-title">六、对未成年人个人信息的特别保护</h3>
              <p class="privacy-paragraph">上海复议非常重视对未成年人个人信息的保护。若你是18周岁以下的未成年人，在使用上海复议的服务前，应确保事先取得监护人的同意。如你在上海复议上申请注册账号，上海复议将默认为你已得到前述同意。上海复议将根据国家相关法律法规及本《个人信息保护政策》的规定保护未成年人的个人信息。</p>
            </div>
            
            <div class="privacy-section">
              <h3 class="privacy-section-title">七、信息安全投诉、举报</h3>
              <p class="privacy-paragraph">如果你对本《个人信息保护政策》有任何疑问，请你联系上海复议，我们会及时解决你的问题。</p>
            </div>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { uuid } from '@/utils';
import Api from '@api/api';
import { addAntiReplayParams } from '@/utils/antireplay';

export default {
  data () {
    var validatePhone = (rule, value, callback) => {
      if (!/^1[3456789]\d{9}$/.test(this.ruleForm.phone)) {
        callback(new Error('请输入正确的手机号码'));
      } else {
        callback();
      }
    };
    var validateName = (rule, value, callback) => {
      if (/\s+/g.test(this.ruleForm.loginName) || value === '') {
        callback(new Error('请输入正确的姓名'));
      } else {
        callback();
      }
    };

    var validateIdCard = (rule, value, callback) => {
      if (!/^[1-9]\d{5}(?:18|19|20|21|22)\d{2}(?:0[1-9]|10|11|12)(?:0[1-9]|[1-2]\d|30|31)\d{3}[\dXx]$/.test(this.ruleForm.identificationCard) || value === '') {
        callback(new Error('请输入正确的证件号码'));
      } else {
        callback();
      }
    };

    const moduleCodeSwitch = () => {
      switch (localStorage.getItem('oprate')) {
        case 'apply':
          return '1';
        case 'search':
          return '2';
        case 'revokeApply':
          return '3';
        default:
          return '1';
      }
    };

    return {
      isDisabled: false, // 控制按钮是否可以点击
      content: '获取验证码', // 发送验证码按钮的初始显示文字
      timer: null, // 定时器
      count: null,
      agreePolicy: false, // 是否同意政策
      privacyPolicyVisible: false, // 隐私政策弹窗是否显示
      ruleForm: {
        identificationCard: '',
        identificationType: '1001001',
        loginName: '',
        phone: '',
        verificationCode: null,
        moduleCode: moduleCodeSwitch(),
        id: '' // 验证码失效时需要传
      },
      rules: {
        loginName: [
          { required: true, validator: validateName, trigger: 'blur' }
        ],
        identificationType: [
          { required: true, message: '请选择证件类型', trigger: 'blur' }
        ],
        identificationCard: [
          { required: true, validator: validateIdCard, trigger: 'blur' }
        ],
        phone: [
          { required: true, validator: validatePhone, trigger: 'blur' }
        ],
        verificationCode: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ]
      },
      labelPosition: 'left'
    };
  },
  mounted () {
    // 从 store 中获取数据
    const user = this.$store.state.user;
    
    if (user.loginName) {
      this.ruleForm.loginName = user.loginName;
    }
    if (user.identificationCard) {
      this.ruleForm.identificationCard = user.identificationCard;
    }
    if (user.phone) {
      this.ruleForm.phone = user.phone;
    }
    
    // 如果 store 中没有数据，则从 localStorage 中获取（备用）
    if (!this.ruleForm.loginName || !this.ruleForm.identificationCard || !this.ruleForm.phone) {
      // 优先从 applicantInfo 中获取（login.vue 中存储的数据）
      const applicantInfo = localStorage.getItem('applicantInfo');
      if (applicantInfo) {
        try {
          const localUser = JSON.parse(applicantInfo);
          if (!this.ruleForm.loginName && localUser.loginName) {
            this.ruleForm.loginName = localUser.loginName;
          }
          if (!this.ruleForm.identificationCard && localUser.identificationCard) {
            this.ruleForm.identificationCard = localUser.identificationCard;
          }
          if (!this.ruleForm.phone && localUser.phone) {
            this.ruleForm.phone = localUser.phone;
          }
        } catch (e) {
          console.error('解析 applicantInfo 失败', e);
        }
      }
      
      // 如果还没有身份证号，尝试从 loginIdentificationCard 获取
      if (!this.ruleForm.identificationCard) {
        const loginIdentificationCard = localStorage.getItem('loginIdentificationCard');
        if (loginIdentificationCard) {
          this.ruleForm.identificationCard = loginIdentificationCard;
        }
      }
      
      // 如果还没有姓名，尝试从 loginName 获取
      if (!this.ruleForm.loginName) {
        const loginName = localStorage.getItem('loginName');
        if (loginName) {
          this.ruleForm.loginName = loginName;
        }
      }
      
      // 最后尝试从 userInfo 中获取（其他可能的来源）
      if (!this.ruleForm.loginName || !this.ruleForm.identificationCard || !this.ruleForm.phone) {
        const userInfo = localStorage.getItem('userInfo');
        if (userInfo) {
          try {
            const localUser = JSON.parse(userInfo);
            if (!this.ruleForm.phone && localUser.mobile) {
              this.ruleForm.phone = localUser.mobile;
            }
            if (!this.ruleForm.loginName && localUser.name) {
              this.ruleForm.loginName = localUser.name;
            }
            if (!this.ruleForm.identificationCard && localUser.idcard) {
              this.ruleForm.identificationCard = localUser.idcard;
            }
          } catch (e) {
            console.error('解析 userInfo 失败', e);
          }
        }
      }
    }
    
    if (document.body.clientWidth <= 750) {
      this.labelPosition = 'top';
    } else {
      this.labelPosition = 'left';
    }
    window.onresize = () => {
      return (() => {
        if (document.body.clientWidth <= 750) {
          this.labelPosition = 'top';
        } else {
          this.labelPosition = 'left';
        }
      })();
    };
  },
  beforeDestroy () {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
  methods: {
    // 获取验证码
    getNumberCode () {
      // 校验身份证号
      if (!/^[1-9]\d{5}(?:18|19|20|21|22)\d{2}(?:0[1-9]|10|11|12)(?:0[1-9]|[1-2]\d|30|31)\d{3}[\dXx]$/.test(this.ruleForm.identificationCard)) {
        this.$toast('请输入正确的证件号码');
        return;
      }
      // 校验手机号
      if (!/^1[3456789]\d{9}$/.test(this.ruleForm.phone)) {
        this.$toast('请输入正确的手机号码');
        return;
      }
      // 校验姓名
      if (!this.ruleForm.loginName || /\s+/g.test(this.ruleForm.loginName)) {
        this.$toast('请输入正确的姓名');
        return;
      }

      this.isDisabled = false;
      
      // 准备请求参数
      const requestParams = {
        phone: this.ruleForm.phone,
        identificationCard: this.ruleForm.identificationCard,
        id: this.ruleForm.id,
        loginText: this.ruleForm.loginName || ''
      };
      
      // 添加防重放攻击参数（签名、nonce、timestamp）
      const secureParams = addAntiReplayParams(requestParams);
      
      Api.getcode(secureParams).then(
        (res) => {
          this.isDisabled = false;
          this.ruleForm.id = res.data.data;
          if (res.data.code == 0 && res.data.data) {
            this.$toast('验证码已发送');
            const TIME_COUNT = 60;
            this.count = TIME_COUNT;
            this.timer = window.setInterval(() => {
              if (this.count > 0 && this.count <= TIME_COUNT) {
                this.isDisabled = true;
                this.count--;
                this.content = this.count + 's后重新获取';
              } else {
                this.isDisabled = false;
                this.content = '获取验证码';
                clearInterval(this.timer);
                this.timer = null;
              }
            }, 1000);
          }
        }
      );
    },
    // 取消
    cancel () {
      this.$router.push({ name: 'MCodeSearch' });
    },
    // 显示隐私政策弹窗
    goToPrivacyPolicy () {
      this.privacyPolicyVisible = true;
    },
    // 关闭隐私政策弹窗
    closePrivacyPolicy () {
      this.privacyPolicyVisible = false;
    },
    // 提交表单
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 检查是否同意政策
          if (!this.agreePolicy) {
            this.$toast('上海复议个人信息保护政策');
            return;
          }
          // 校验手机验证码
          Api.checkCerificationCode({
            loginName: this.ruleForm.loginName,
            identificationType: this.ruleForm.identificationType,
            identificationCard: this.ruleForm.identificationCard,
            phone: this.ruleForm.phone,
            verificationCode: this.ruleForm.verificationCode,
            id: this.ruleForm.id,
            loginText: ''
          }).then(({ data }) => {
            if (data.code == 0) {
              // 验证码校验成功，检查用户是否已注册
              this.submitRegister();
            } else {
              if (data.msg && !['系统异常', '后台服务异常'].includes(data.msg)) {
                this.$toast(data.msg);
              } else if (!data.msg) {
                this.$toast('验证码错误');
              } else {
                console.error('Error:', data.msg);
              }
            }
          }).catch((err) => {
            console.error('验证码校验失败', err);
            this.$toast('验证码校验失败，请重试');
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 检查用户是否已注册
    // 提交注册
    submitRegister () {
      const { loginName, identificationCard, phone } = this.ruleForm
      
      // 准备注册参数（参考小程序端）
      const requestParams = {
        name: loginName,
        identificationCard: identificationCard,
        phone: phone,
        verificationCode: this.ruleForm.verificationCode,
      }
      
      // 添加防重放攻击参数
      const secureParams = addAntiReplayParams(requestParams)
      
      // 先调用注册接口
      Api.userSave(secureParams).then(res => {
        console.log('userSave res', res)
        if (res.data.code === '0') {
          // 注册成功，保存手机号到localStorage
          localStorage.setItem('phone', phone)
          localStorage.setItem('phoneNumber', phone)
          localStorage.setItem('isRegistered', 'true')
          
          this.$message.success('注册成功')
          
          // 注册成功后，调用登录接口
          this.saveLoginInfoAndGoHome()
        } else {
          this.loading = false
          // this.$message.error(res.data.msg || '注册失败，请重试')
        }
      }).catch(err => {
        this.loading = false
        console.log('userSave error', err)
        // this.$message.error('注册失败，请重试')
      })
    },
    // 保存登录信息并回到首页
    saveLoginInfoAndGoHome (wssqUser) {
      const { loginName, identificationCard, phone, identificationType } = this.ruleForm;
      const oprate = localStorage.getItem('oprate') || 'apply';
      
      const params = {
        loginName: loginName,
        identificationType: identificationType,
        identificationCard: identificationCard,
        phone: phone,
        isFace: oprate == 'apply' ? 1 : null,
        isToWithdraw: oprate == 'revokeApply' ? 1 : null,
        verificationCode: this.ruleForm.verificationCode,
        moduleCode: this.ruleForm.moduleCode,
        id: this.ruleForm.id,
        loginText: loginName
      };

      Api.saveLoginInfo(params).then((res) => {
        console.log('saveLoginInfo', res);
        if (res.data.code === '0') {
          // 保存用户信息
          localStorage.setItem('loginIdentificationCard', identificationCard);
          localStorage.setItem('loginName', loginName);
          if (wssqUser) {
            localStorage.setItem('wssqUser', JSON.stringify(wssqUser));
          }
          // 保存登录状态
          localStorage.setItem('isLogin', 'true');
          localStorage.setItem('isRegistered', 'true');
          
          this.$toast({
            message: '登录成功',
            type: 'success'
          });
          
          // 回到首页
          setTimeout(() => {
            this.$router.push({ name: 'MCodeSearch' });
          }, 1000);
        } else {
          this.$toast({
            message: res.data.msg || '登录失败，请重试',
            duration: 4000
          });
        }
      }).catch((err) => {
        console.log('saveLoginInfo error', err);
        this.$toast({
          message: '登录失败，请重试',
          duration: 4000
        });
      });
    },
     // 获取注册状态弹窗内容
    getRegestStatusDialogContent () {
      Api.getRegestStatusDialogContent().then((res) => {
        if (res.data && res.data.code === '0') {
          const tips = res.data.data?.tips || '';
          const phone = res.data.data?.phone || '';
          const time = res.data.data?.time || '';
          
          if (tips) {
            this.$dialog.alert({
              title: '提示',
              message: tips + (phone ? '\n电话: ' + phone : '') + (time ? '\n时间: ' + time : '')
            });
          }
        }
      }).catch(() => {
        // 接口调用失败，使用默认提示
      });
    },
  }
};
</script>

<style lang="scss" scoped>
.main-contentBox {
  padding: 16px;
  height: auto;
  .re-contentBox {
    overflow: auto;
    min-height: 380px;
    background: rgba(255, 255, 255, 0.05);
    box-shadow: 2px 6px 10px 0px rgba(128, 126, 189, 0.24);
    border-radius: 8px;
    backdrop-filter: blur(20px);
    display: flex;
    align-items: center;
    justify-content: center;
    .textBox {
      width: 100%;
      padding: 16px;
      
      .auth-tip {
        font-size: 14px;
        color: #333;
        line-height: 22px;
        margin-bottom: 16px;
        text-align: left;
      }
      
      .tiptext {
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: #999999;
        line-height: 37px;
        margin-left: 5px;
      }
    }
  }
}
::v-deep .el-input-group__append, .el-input-group__prepend {
  background: linear-gradient(90deg, #e4c995 0%, #b9916a 100%);
}
.codebtn {
  font-size: 14px;
  color: #FFFFFF;
  cursor: pointer;
}
.codebtn-gary {
  cursor: pointer;
  font-size: 14px;
  font-family: MicrosoftYaHei;
  color: #FFFFFF;
  cursor: not-allowed;
}
@media screen and (max-width: 1000px) {
  .main-contentBox {
    padding: 16px;
  }
  .tiptext {
    font-size: 12px !important;
  }
  .el-input {
    font-size: 12px !important;
  }
}
@media screen and (max-width: 750px) {
  .main-contentBox {
    padding: 16px;
  }

  .main-contentBox .re-contentBox {
    backdrop-filter: none;
  }
  .re-contentBox {
    padding: 16px;
    .el-form-item__content {
      margin-bottom: 0 !important;
      margin-left: 10px !important;
    }
    ::v-deep .el-form-item__label {
      padding: 0px !important;
    }
    .flexEnd {
      display: flex;
      align-items: center;
    }
    .pt10 {
      padding-top: 10px;
    }
    .pt15 {
      padding-top: 15px;
    }
  }
}

.el-form-item {
  width: 100%;
  margin-bottom: 0 !important;
}
@media screen and (max-width: 500px) {
  .main-contentBox {
    padding: 16px;
  }
  .re-contentBox {
    .text-width {
      width: 100% !important;
      padding-top: 0 !important;
    }
    .el-form-item {
      width: 100%;
      margin-bottom: 0 !important;
    }
    ::v-deep .el-form-item__error {
      position: static !important;
    }
    .pt10 {
      padding-top: 36px !important;
    }
  }
}
@media screen and (max-width: 300px) {
  .el-form-item {
    width: 100%;
  }
  .re-contentBox .pt10 {
    padding-top: 10px !important;
  }
}

// 隐私政策相关样式
.privacy-link {
  color: #199CD5;
  margin-left: 4px;
  cursor: pointer;
  text-decoration: underline;
}

.privacy-popup {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #fff;
}

.privacy-popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  border-bottom: 1px solid #eee;
  position: sticky;
  top: 0;
  background: #fff;
  z-index: 10;
}

.privacy-popup-title {
  font-size: 18px;
  font-weight: bold;
  color: #333;
}

.privacy-popup-close {
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: #999;
  cursor: pointer;
}

.privacy-popup-content {
  flex: 1;
  overflow-y: auto;
  padding: 0;
}

.privacy-content {
  padding: 20px;
  font-size: 14px;
  color: #333;
  line-height: 1.8;
}

.privacy-paragraph {
  margin-bottom: 12px;
  text-align: left;
}

.privacy-section {
  margin-bottom: 20px;
}

.privacy-section-title {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  margin-bottom: 12px;
  display: block;
}
</style>

